<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Particuliers</h1>
                    <p>Gestion des contacts</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.person.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un contact</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxcore.person.export')" @click="exportFile('contacts')">
                  <icon name="download-cloud-01"/>
                  <span>Export les résultats (Excel)</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxcore.person.import')" @click="importFile()">
                  <icon name="upload-cloud-01"/>
                  <span>Importer des paiements</span>
                </li>
              </actions-dropdown>

            </div>
        </header>

        <filters v-model="filters" :tabs="tabsFilter" :paginator="paginator" :active-date-filter="true" :active-advanced-filter="false" :active-tabs="true" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

            <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div class="center">
                          <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Prénom', value:'firstname'}, {name:'Nom', value:'lastname'}, {name:'E-mail', value:'email'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="center" role="presentation"><span>Succursale</span></div>
                        <div class="center" role="presentation"><span>Geste commercial</span></div>
                        <div class="center" role="presentation"><span>Langue</span></div>
                        <div class="center" role="presentation"><span>Scope</span></div>
                        <div class="center" role="presentation"><span>Authentification</span></div>
                        <div class="center" role="presentation"><span>Compte validé</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxcore.person.view', item.id )">
                        <div></div>
                        <div class="picture no-radius">
                            <figure>
                              <icon name="user-01"/>
                              <!--
                                <img :src="$iconFolder + 'user-man.svg'" v-if="!item.picture && item.gender != 'f'"/>
                                <img :src="$iconFolder + 'user-woman.svg'" v-if="!item.picture && item.gender == 'f'"/>
                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                                -->
                            </figure>
                        </div>
                        <div data-field="id" class="center" role="presentation"><p class="id">{{ item.id }}</p></div>
                        <div>
                          <strong class="highlight">
                            <span data-field="firstname">{{ item.firstname }}</span>
                            <span data-field="lastname">{{ item.lastname }}</span>
                          </strong>
                          <p class="color">{{ item.email }}</p>
                          <p v-if="item.internal_identifier">No Client: <span class="token">{{ item.internal_identifier }}</span></p>
                          <p v-if="item.addresses.length > 0" style="margin-top: 0.25em;white-space: nowrap;" class="address">
                            <span v-if="item.addresses[0].company">{{ item.addresses[0].company }}</span>
                            <span>{{ item.addresses[0].street }} {{ item.addresses[0].street_number }}</span>
                            <span>{{ item.addresses[0].country_id }}-{{ item.addresses[0].postal_code }} {{ item.addresses[0].locality }}</span>
                          </p>
                        </div>
                        <div data-field="branch" role="presentation">{{ item.branch ? item.branch.name : '' }}</div>
                        <div class="center" role="presentation">
                          <span v-if="item.commercial_gesture">{{ item.commercial_gesture.name }}</span>
                          <span v-else>-</span>
                        </div>
                        <div class="center" role="presentation"><img :src="'/src/assets/flags/'+item.locale+'.svg'" width="16" v-if="item.locale"/></div>
                        <div data-field="scope" class="center" role="presentation"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="status center" role="presentation"><active v-model="item.user.active" v-if="item.user"></active></div>
                        <div class="approved center" role="presentation">
                          <i class="icon icon-order-success status-completed" v-if="item.user && item.user.approved"></i>
                          <i class="icon icon-order-cancel status-error" v-if="item.user && !item.user.approved"></i>
                        </div>
                        <div class="actions">
                            <ul>
                                <li v-show="$aclInterfaceValidator('weeboxcore.person.delete', item.id)">
                                    <button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-show="$aclInterfaceValidator('weeboxcore.person.update', item.id)">
                                    <button @click="edit(item.id)"><icon name="pencil-02"/></button>
                                </li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import PersonService from './PersonService.js';
    import Index from '../../layouts/Index.vue';

    export default {
      extends: Index,
        data () {
            return {
              tabsFilter: [
                {
                  slug: '',
                  name: 'Tout'
                },
                {
                  slug: 'is_approved',
                  name: 'Comptes approuvés'
                },
                {
                  slug: 'is_not_approved',
                  name: 'Comptes à valider'
                }
              ],
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return PersonService;
            },
          toto: function(value){
            return value
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/person/Index.vue